<template>
    <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
            <div class="row dashboard-border">
                <div class="col-lg-3 col-7 align-self-center col-md-5">
                    <img src="../../assets/icons/projects.png" height="32" width="32"/>
                    <span class="mx-2"> Manage My Projects </span>
                </div>
                <div class="col-lg-9 col-5 text-end align-self-center col-md-7">
                    <button @click="AddProjectNew()" class="btn" type="button"
                            style="background-color: #56759c;color:#ffffff">
                        <font-awesome-icon icon="plus" class="icon" size="sm"/>
                        <span style="color: #ffffff;font-weight: unset" class="mx-1">Add My Project</span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-9">
                    <div v-if="!isLoading" class="row modified-table mt-3 table-responsive">
                        <dynamic-table :gridconfig="gridconfig" :gridData="filteredUserProjects"
                                       :gridMainConfig="gridMainConfig"
                                       @dynamic-button="TryUpdateProject"></dynamic-table>
                    </div>
                    <div v-else>
                        <LoadingButton/>
                    </div>
                </div>
                <div class="col-md-3 mt-3">
                    <manage-side-form :project-form="this.projectInfoForm"
                                      :modal-form="this.modalInfoForm"></manage-side-form>
                </div>
            </div>
        </div>
        <div class="col-md-1"></div>
    </div>
</template>
<script>


    import {loadingMixin} from "../../utils/mixins";
    import LoadingButton from "../../components/ui/LoadingButton";
    import ManageSideForm from "../../components/ui/ManageSideForm";
    import DynamicTable from "../../components/ui/DynamicTable";
    //import vSelect from "vue-select";

    import {mapActions, mapState} from "vuex";

    export default {
        name: "ManageMyProject",
        mixins: [loadingMixin],
        components: {
            LoadingButton,
            ManageSideForm,
            //vSelect,
            DynamicTable
        },
        data() {
            return {
                searchTextProject: "",
                searchTextUser: "",
                selectedProject: 0,
                selectedProjectPrivate: 1,
                selectedUsers: [],
                sortedbyASC: true,
                asc: true,
                gridconfig: [
                    {fieldName: 'groupName', fieldTitle: 'Group Name', type: 'text', icon: '', format: ''},
                    {fieldName: 'projectCode', fieldTitle: 'Project Code', type: 'text', icon: '', format: ''},
                    {fieldName: 'loginId', fieldTitle: 'Username', type: 'text', icon: '', format: ''},
                    {fieldName: 'password', fieldTitle: 'Password', type: 'password', icon: '', format: ''},
                ],
                gridMainConfig: {
                    pagination: false, sorting: false
                },
                projectInfoForm: {
                    id: 0,
                    projectCode: "",
                    groupName: "",
                    loginId: "",
                    password: "",
                    register: "",
                    remember: true,
                    submitting: true,
                    token: "",
                    userId: 0,
                },
                modalInfoForm: {
                    isActiveProjectModal: false,
                    isEmptyDiv: true,
                }
            }
        },

        methods: {
            ...mapActions('externalProject', ['getExternalInfo', 'getExternalInfos', 'AddExternalInfo']),
            //...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),
            ...mapActions('users', ['getUsers']),


            async AddProjectNew() {
                let scrollForm = document.querySelector('.projectForm');
                scrollForm.scrollIntoView(true);
                this.projectInfoForm.id = 0;
                this.projectInfoForm.groupName = "";
                this.projectInfoForm.projectCode = "";
                this.projectInfoForm.loginId = "";
                this.projectInfoForm.password = "";
                this.projectInfoForm.register = "";
                this.projectInfoForm.remember = true;
                this.projectInfoForm.submitting = true;
                this.projectInfoForm.token = "";
                this.projectInfoForm.userId = "";
                this.modalInfoForm.isEmptyDiv = false;
                this.modalInfoForm.isActiveProjectModal = true;
            },
            async TryUpdateProject(value) {
                let scrollForm = document.querySelector('.projectForm');
                scrollForm.scrollIntoView(true);
                this.modalInfoForm.isEmptyDiv = false;
                this.modalInfoForm.isActiveProjectModal = true;
                try {
                    await this.getExternalInfo(value);
                    this.projectInfoForm.id = value.id;
                    this.projectInfoForm.groupName = value.groupName;
                    this.projectInfoForm.loginId = value.loginId;
                    this.projectInfoForm.password = value.password;

                    this.projectInfoForm.projectCode = value.projectCode;
                    this.projectInfoForm.register = value.register;
                    this.projectInfoForm.remember = value.remember;

                    this.projectInfoForm.submitting = value.submitting;
                    this.projectInfoForm.token = value.token;
                    this.projectInfoForm.userId = value.userId;


                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e.message});

                }
            },
            async sortList(sortBy) {
                if (this.sortedbyASC) {
                    this.projects.sort((x, y) => (x[sortBy] > y[sortBy] ? -1 : 1));
                    this.sortedbyASC = false;
                    this.asc = false
                } else {
                    this.projects.sort((x, y) => (x[sortBy] < y[sortBy] ? -1 : 1));
                    this.sortedbyASC = true;
                    this.asc = true
                }
            },
        },

        computed: {
            ...mapState('externalProject', ['externalUserInfo', 'externalUserInfos']),
            ...mapState('auth', ['user']),

            /*
            searchProjects: function () {
              return this.projects.filter((post) => {
                return post.projectName.toUpperCase().match(this.searchTextProject.toUpperCase())
                    || post.projectCode.toUpperCase().match(this.searchTextProject.toUpperCase());
              });
            },
            searchProjectUsers: function () {
              return this.userProject.filter((post) => {
                return post.userName.toUpperCase().match(this.searchTextUser.toUpperCase());
              }).sort((a, b) => (a.createDT < b.createDT) ? 1 : -1)
            },*/
            filteredUserProjects: function () {
                return this.externalUserInfos.filter((post) => {
                    console.log(post)
                    return post.userId == this.user.userId;
                })
            },

        }
        ,
        async beforeMount() {
            this.showLoading();
            try {
                //await this.getExternalInfo({userId: this.user.userId, projectCode:this.projectInfoForm.projectCode});
                await this.getExternalInfos();
            } finally {
                this.hideLoading();
            }

        }
        ,
        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)//ESC
                {
                    this.isActiveUserModal = false
                }
            })
        }
        ,
    }
</script>


<style scoped>

    .search-title {
        clear: both;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
    }

    .project-main {
        font-family: Poppins;
    }

    .modified-button {
        background-color: #1e3e67;
        color: white;
    }

    .modified-a {
        color: #1e3e67;
    }

    .table-font {
        font-size: 13px;
        font-family: Helvetica, Arial;
        border-left: 1px solid #dfe0e1;
    }

</style>
